import _defineProperty from "/opt/build/repo/website/node_modules/@babel/runtime/helpers/esm/defineProperty";
export var dispatchFunction = function dispatchFunction(identity) {
  return identity;
};
export function dispatch() {
  return dispatchFunction(arguments.length <= 0 ? undefined : arguments[0]);
}
export function setDispatch(func) {
  dispatchFunction = func;
}
export function bindToDispatch(func) {
  return function () {
    return dispatch(func.apply(void 0, arguments));
  };
}
export function bindActionMapToDispatch(actionCreators) {
  return Object.keys(actionCreators).reduce(function (result, key) {
    return Object.assign(result, _defineProperty({}, key, function () {
      return dispatch(actionCreators[key].apply(actionCreators, arguments));
    }));
  }, {});
}